import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import API from "../../../services/API";

export default function CourseDisciplines({id}){

    const [status, setStatus] = useState('loading')

    const [options, setOptions] = useState([])

    const [value, setValue] = useState([])

    useEffect(() => {

        load(id).then(data => {

            setOptions(data.options)
            setValue(data.value)
            setStatus('ready')

        })
        .catch(_ => setStatus('error'))

    }, [id])

    const handleChange = (_, newValue) => {
        
        const previousValue = [...value];

        setValue(newValue)

        API.post(`/courses/${id}/disciplines`, newValue)
            .catch(_ => setValue(previousValue))
    }


    return status === 'ready' &&

        <Autocomplete
            multiple
            options={options}
            value={value}
            onChange={handleChange}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            renderInput={(params) => 
                <TextField 
                    {...params} 
                    label="Mots clés"
                    size='small'
                />
            }
        />
}


async function load(id){

    let data = {options: [], value: []};

    let response1 = await API.get(`/disciplines`);

    data.options = response1.data.map(tag => {
        return {id: tag.id, label: tag.title}
    });

    let response2 = await API.get(`/courses/${id}/disciplines`);

    data.value = response2.data.map(tag => {
        return {id: tag.id, label: tag.title}
    });

    return data;
}